import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const SportsIcon = ({ color = '#fff', size = 15, ...props }) => (
  <svg
    width={size}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 14 14"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.417 14C13.3 14 14 13.288 14 12.427c0-.877-.717-1.572-1.583-1.572-.883 0-1.583.712-1.583 1.572 0 .861.7 1.573 1.583 1.573zM10.101 3.04c.833.1 1.6-.496 1.7-1.324.1-.844-.5-1.605-1.333-1.705-.867-.1-1.616.48-1.717 1.325-.1.843.5 1.588 1.35 1.705zm-7.115.348c.366-.464.733-.927 1.1-1.407.133-.182.3-.248.533-.215 1.017.132 2.05.231 3.066.364a1.1 1.1 0 0 1 .533.231c.533.414 1.033.86 1.55 1.292.282.231.399.53.35.893-.067.497-.117.994-.167 1.49 0 .066-.017.116-.017.199a.741.741 0 0 0 .184.017l1.683.198c.4.05.65.331.616.712-.05.381-.366.63-.767.58-.899-.1-1.815-.216-2.716-.315-.283-.033-.416-.198-.383-.48l.15-1.258v-.083c-.5.613-1 1.192-1.5 1.788.05.05.1.083.133.116.5.397 1 .795 1.5 1.176a.74.74 0 0 1 .3.712l-.45 3.873c-.05.48-.4.762-.9.712-.482-.05-.749-.281-.799-.679-.017-.083 0-.149.017-.231.133-1.093.25-2.185.383-3.278.017-.083.017-.15-.066-.216a83.774 83.774 0 0 1-1.45-1.076l-.583-.58c-.083-.082-1.016-1.058-.217-2.052.617-.778 1.233-1.556 1.866-2.334.034-.05.084-.1.134-.166a.51.51 0 0 0-.134-.033c-.616-.066-1.25-.149-1.866-.215-.116-.017-.166.017-.233.1-.266.33-.516.662-.783.993-.266.33-.65.38-.966.148-.334-.231-.367-.645-.101-.976zM.004 8.421c.033-.364.2-.662.55-.828.25-.115.483-.066.7.066l1.8.994c.05.033.1.066.183.1.033-.067.066-.117.083-.166.333-.597.3-.53.633-1.126.017-.017.134-.232.233-.397.1.53.4.976.667 1.258l.366.364c-.35.63-.716 1.275-1.05 1.871-.2.364-.433.43-.8.232A257.567 257.567 0 0 0 .42 9.166c-.266-.182-.45-.414-.416-.745z"
      fill={color}
    />
  </svg>
);

SportsIcon.propTypes = propTypes;

export default SportsIcon;
